export default "__VITE_ASSET__BxjWLE4h__"